module.exports = __webpack_public_path__ + "img/ts8.f1dbb2cc.png";